// exclude-from-index
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { SpaceSmall, SpaceMedium, SpaceLarge } from './Spacer.styles';

class Spacer extends PureComponent {
  static propTypes = {
    size: PropTypes.oneOf(['sm', 'md', 'lg']).isRequired,
    children: PropTypes.node
  };

  static defaultProps = {
    children: undefined
  };

  render() {
    const { children, size } = this.props;

    return (
      <Fragment>
        {size === 'sm' && <SpaceSmall>{children}</SpaceSmall>}
        {size === 'md' && <SpaceMedium>{children}</SpaceMedium>}
        {size === 'lg' && <SpaceLarge>{children}</SpaceLarge>}
        {!size && children}
      </Fragment>
    );
  }
}

export default Spacer;
